import { of } from 'rxjs';
import type { Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import type { Action } from 'redux';

import { LogService } from '../../services/log-service';
import Global from '../../store/global-selectors';
import { UserPermissionService } from '../../services/user-permission-service';
import { US } from '../../constants/country-codes';
import { APP_INITIALIZATION } from '../core/base-actions';
import { getSellerRecommendations as getSellerRecommendationsApi } from './api/seller-recommendations.api';
import { GET_SELLER_RECOMMENDATIONS, getSellerRecommendationsSuccess } from './seller-recommendations.actions';

const isEligibleForRecommendations = (state: object): boolean => {
  const homeCountry = Global.selectSellerHomeCountry(state);
  if (homeCountry !== US) return false;

  const isAccountOwner = Global.selectUserIsAccountOwner(state);
  const userRoles = Global.selectUseruserRoles(state);
  return (
    isAccountOwner ||
    UserPermissionService.userHasAdministrationRole(userRoles) ||
    UserPermissionService.userHasAccountManagementRole(userRoles)
  );
};

export const getSellerRecommendations = (action$: Observable<Action>, { getState }: { getState: () => object }) =>
  action$.pipe(
    ofType(APP_INITIALIZATION, GET_SELLER_RECOMMENDATIONS),
    mergeMap(() => {
      if (!isEligibleForRecommendations(getState())) {
        return of(getSellerRecommendationsSuccess([]));
      }

      return getSellerRecommendationsApi().pipe(
        map((recommendations) => {
          return getSellerRecommendationsSuccess(recommendations);
        }),
        catchError((error) => {
          LogService.logInfo('Failed to load seller recommendations', error);
          return of(getSellerRecommendationsSuccess([]));
        }),
      );
    }),
  );
